<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useDisciplineModalDelete } from '../../model/discipline-modal-delete.hook'

defineOptions({
  name: 'ModalDisciplineDelete',
})

const {
  refIsOpen,
  refIsLoading,
  refDetail,
  closeModal,
  confirmDelete,
} = useDisciplineModalDelete()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Delete discipline"
    is-close-icon
    @click:confirm="confirmDelete"
    @click:cancel="closeModal"
  >
    <template #content>
      <AppText
        name="body1"
        color="slate-700"
      >
        {{ refDetail }}
      </AppText>
    </template>
  </ModalConfirmation>
</template>
